import {
	AppBar,
	Badge,
	Button,
	Divider,
	Hidden,
	IconButton,
	ListSubheader,
	Menu,
	MenuItem,
	Toolbar,
} from "@material-ui/core";
import {
	AccountCircle,
	ExpandMore,
	Menu as MenuIcon,
	NotificationsNoneOutlined,
} from "@material-ui/icons";
import { connect } from "common/connect";
import { changeUrl } from "common/history";
import Store from "common/store";
import StoreKeys from "common/storeKeys";
import UserManager from "common/userManager";
import { ReactComponent as PickstopLogo } from "icons/PickstopLogoNew.svg";
import React from "react";
import { withRouter } from "react-router-dom";
import * as Styles from "./styles";
import { useEffect } from "react";
import UserProfileModalHelper from "common/helpers/userProfileModalHelper";
import NotificationService from "services/NotificationService";
// eslint-disable-next-line no-unused-vars
import { NotificationDto } from "common/types/NotificationDto";
import { NotificationClickAction } from "common/constants/NotificationClickAction";
import NameplateService from "services/NameplateService";
import ModalHelper from "common/helpers/modalHelper";
import NameplateSelectorModal from "common/components/Modals/NameplateSelectorModal/NameplateSelectorModal";
import UserService from "services/UserService";
import { SetLoading } from "common/components/Loader/Loader";
import LookupService from "services/LookupService";
import TopIconMenu from "./TopIconMenu";
import { getCurrentTabFromRoute } from "./useTabSelect";
import { useLocation } from "react-router-dom";
import { GetCurrentGameId, SetGameGlobally } from "common/constants/Games";

const propKeys = {
	games: StoreKeys.GAMES,
	roles: StoreKeys.ROLES,
	open: StoreKeys.LeftPane.Open,
	notifications: StoreKeys.NOTIFICATIONS.LIST,
	readNotifications: StoreKeys.NOTIFICATIONS.READ,
	isLoggedIn: StoreKeys.USER.LOGGED_IN,
	username: StoreKeys.USER.USERNAME,
	currentSurvey: StoreKeys.SURVEY.CURRENT,
};

function NavMenuC(props) {
	const classes = Styles.styles();
	const gameMenuClasses = Styles.gameMenu();
	const [mainAnchorEl, setMainAnchorEl] = React.useState(null);
	const [userAnchorEl, setUserAnchorEl] = React.useState(null);
	const [notificationAnchorEl, setNotificationAnchorEl] = React.useState(null);
	const [compactAnchorEl, setCompactAnchorEl] = React.useState(null);
	const location = useLocation();
	const tab = getCurrentTabFromRoute(location);

	const gameId = GetCurrentGameId();
	const selectedGame = props.games?.find((game) => game.id === gameId);
	const isLoggedIn = props.isLoggedIn;
	const userId = UserManager.getUserId();
	const username = props.username;
	const isAdmin =
		props.roles?.includes("Admin") ||
		props.roles?.includes("EventCreator") ||
		props.roles?.includes("SurveyCreator");
	let unreadNotificationCount = props.notifications?.length;

	if (props.readNotifications && props.notifications) {
		unreadNotificationCount = props.notifications.filter(
			(n) => !props.readNotifications.includes(n.id)
		).length;
	}

	useEffect(() => {
		if (!props.games) {
			LookupService.getGames().then((games) => {
				Store.set(StoreKeys.GAMES, games);
			});
		}
		if (isLoggedIn && !props.notifications) {
			NotificationService.getNotifications().then((notifications) => {
				Store.set(StoreKeys.NOTIFICATIONS.LIST, notifications);
			});
		}
	}, [isLoggedIn, props.games, props.notifications]);

	const handleMainMenuClick = (event) => {
		setMainAnchorEl(event.currentTarget);
	};

	const handleMainMenuClose = () => {
		setMainAnchorEl(null);
	};

	const handleNotificationMenuClick = (event) => {
		setNotificationAnchorEl(event.currentTarget);
	};

	const handleNotificationMenuClose = () => {
		setNotificationAnchorEl(null);
	};

	const handleUserMenuClick = (event) => {
		setUserAnchorEl(event.currentTarget);
	};

	const handleUserMenuClose = () => {
		setUserAnchorEl(null);
	};

	const handleCompactMenuClick = (event) => {
		setCompactAnchorEl(event.currentTarget);
	};

	const handleCompactMenuClose = () => {
		setCompactAnchorEl(null);
	};

	const onSelectPremiumNameplateAction = () => {
		Promise.all([
			UserService.getUserCardInfo(userId),
			NameplateService.getUserNameplateOptions(),
		]).then(([userCard, nameplates]) => {
			const pinnedTrophy = !!userCard ? userCard.pinnedTrophy[0] : null;
			ModalHelper.openModal(<NameplateSelectorModal />, () => {}, {
				header: "Unlock 1 Patron reward nameplate for this month",
				userId,
				username,
				nameplates,
				pinnedEventName: pinnedTrophy?.eventName,
				pinnedTrophyImagePath: pinnedTrophy?.imagePath,
				onSelect: selectNameplate.bind(this),
				hideDefault: true,
			});
		});
	};

	const selectNameplate = (nameplate) => {
		ModalHelper.closeAllModals();
		SetLoading(true, "Saving Nameplate");
		NameplateService.selectNameplate(nameplate.id).then(() => {
			SetLoading(false);
		});
	};

	/**
	 *
	 * @param {NotificationDto} notification
	 */
	const handleNotificationClicked = (notification) => {
		handleNotificationMenuClose();

		NotificationService.readNotification(notification);
		switch (notification.onClickAction) {
			case NotificationClickAction.SelectPremiumNameplate:
				onSelectPremiumNameplateAction();
				break;
			case NotificationClickAction.ViewTrophy:
				// Not used.
				break;
			case NotificationClickAction.OpenProfile:
				const userId = UserManager.getUserId();
				UserProfileModalHelper.openProfile(userId);
				break;
			default:
				console.warn(
					`Failed to implement notification click action, ${notification.onClickAction}, in NavMenu.js`
				);
				break;
		}
	};

	const handleSetGame = (newGameId) => {
		SetGameGlobally(gameId, newGameId, true);
	};

	const handleDrawerToggle = () => {
		Store.set(StoreKeys.LeftPane.Open, !props.open);
	};

	const renderCompactMenu = () => (
		<div className={classes.compactMenuArea}>
			{!isLoggedIn && (
				<Button
					className={`${classes.authLink} ${classes.authAccent}`}
					onClick={() => {
						UserManager.openLoginModal();
					}}
				>
					Sign in
				</Button>
			)}
			<IconButton
				size="small"
				className={classes.bellButton}
				aria-label="menu"
				aria-controls="menu-compact"
				aria-haspopup="true"
				onClick={handleCompactMenuClick}
			>
				<Badge
					variant="dot"
					invisible={!unreadNotificationCount}
					classes={{ dot: classes.bellDot }}
				>
					<AccountCircle className={classes.bellIcon} />
				</Badge>
			</IconButton>
			<Menu
				id="menu-compact"
				classes={{ paper: classes.compactMenuPaper }}
				anchorEl={compactAnchorEl}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				getContentAnchorEl={null}
				open={Boolean(compactAnchorEl)}
				onClose={handleCompactMenuClose}
			>
				{props.games && props.games.length > 0 && (
					<ListSubheader className={classes.menuSectionHeader} disableSticky>
						Game
					</ListSubheader>
				)}
				{props.games?.map((game) => {
					const isCurrent = game.id === gameId;
					return (
						<MenuItem
							key={`compact-game-${game.id}`}
							className={isCurrent ? classes.gameMenuItemActive : ""}
							onClick={() => {
								handleSetGame(game.id);
								handleCompactMenuClose();
							}}
						>
							{game.name}
						</MenuItem>
					);
				})}

				{isLoggedIn && <Divider />}
				{isLoggedIn && (
					<ListSubheader className={classes.menuSectionHeader} disableSticky>
						Notifications
						{unreadNotificationCount ? ` (${unreadNotificationCount})` : ""}
					</ListSubheader>
				)}
				{isLoggedIn && props.notifications?.length === 0 && (
					<MenuItem
						disabled
						onClick={() => {
							handleCompactMenuClose();
						}}
					>
						No notifications
					</MenuItem>
				)}
				{isLoggedIn &&
					props.notifications?.slice(0, 5).map((notification, i) => (
						<MenuItem
							className={classes.notification}
							key={`compact-notif-${i}`}
							onClick={() => {
								handleNotificationClicked(notification);
								handleCompactMenuClose();
							}}
						>
							{notification.html && (
								<div
									dangerouslySetInnerHTML={{ __html: notification.html }}
								></div>
							)}
						</MenuItem>
					))}

				{isLoggedIn && <Divider />}
				{isLoggedIn && (
					<ListSubheader className={classes.menuSectionHeader} disableSticky>
						{username}
					</ListSubheader>
				)}
				{isLoggedIn && (
					<MenuItem
						onClick={() => {
							const id = UserManager.getUserId();
							UserProfileModalHelper.openProfile(id);
							handleCompactMenuClose();
						}}
					>
						Profile
					</MenuItem>
				)}
				{isLoggedIn && isAdmin && (
					<MenuItem
						onClick={() => {
							changeUrl("/admin");
							handleCompactMenuClose();
						}}
					>
						Admin
					</MenuItem>
				)}
				{isLoggedIn && (
					<MenuItem
						onClick={() => {
							handleCompactMenuClose();
							UserManager.logout().then(() => {
								changeUrl("/");
							});
						}}
					>
						Log Out
					</MenuItem>
				)}

				{!isLoggedIn && <Divider />}
				{!isLoggedIn && (
					<MenuItem
						onClick={() => {
							handleCompactMenuClose();
							UserManager.openRegisterModal();
						}}
					>
						Register
					</MenuItem>
				)}
			</Menu>
		</div>
	);

	const renderAuthMenuItems = () => {
		return (
			<div className={classes.authButtons}>
				{isLoggedIn && (
					<>
						<IconButton
							size="small"
							className={classes.bellButton}
							aria-label="notifications"
							aria-controls="menu-notifications"
							aria-haspopup="true"
							onClick={handleNotificationMenuClick}
							disabled={!props.notifications}
						>
							<Badge
								variant="dot"
								invisible={!unreadNotificationCount}
								classes={{ dot: classes.bellDot }}
							>
								<NotificationsNoneOutlined className={classes.bellIcon} />
							</Badge>
						</IconButton>
						<Menu
							id="menu-notifications"
							classes={{ paper: classes.menu }}
							anchorEl={notificationAnchorEl}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "right",
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "right",
							}}
							getContentAnchorEl={null}
							open={Boolean(notificationAnchorEl)}
							onClose={handleNotificationMenuClose}
						>
							{props.notifications?.length === 0 && (
								<MenuItem
									onClick={() => {
										handleNotificationMenuClose();
									}}
								>
									No notifications
								</MenuItem>
							)}
							{props.notifications?.map((notification, i) => (
								<MenuItem
									className={classes.notification}
									key={i}
									onClick={() => {
										handleNotificationClicked(notification);
										handleNotificationMenuClose();
									}}
								>
									{notification.html && (
										<div
											dangerouslySetInnerHTML={{ __html: notification.html }}
										></div>
									)}
								</MenuItem>
							))}
						</Menu>
						<span className={classes.userSep} aria-hidden="true" />
						<Button
							classes={gameMenuClasses}
							aria-controls="menu-user"
							aria-haspopup="true"
							onClick={handleUserMenuClick}
							endIcon={<ExpandMore />}
						>
							<span className={classes.username}>{username}</span>
						</Button>
						<Menu
							id="menu-user"
							classes={{ paper: classes.menu }}
							anchorEl={userAnchorEl}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "right",
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "right",
							}}
							getContentAnchorEl={null}
							open={Boolean(userAnchorEl)}
							onClose={handleUserMenuClose}
						>
							<MenuItem
								onClick={() => {
									const userId = UserManager.getUserId();
									UserProfileModalHelper.openProfile(userId);
									handleUserMenuClose();
								}}
							>
								Profile
							</MenuItem>
							{isAdmin && (
								<MenuItem
									onClick={() => {
										changeUrl("/admin");
										handleUserMenuClose();
									}}
								>
									Admin
								</MenuItem>
							)}
							<MenuItem
								onClick={() => {
									handleUserMenuClose();
									UserManager.logout().then(() => {
										changeUrl("/");
									});
								}}
							>
								Log Out
							</MenuItem>
						</Menu>
					</>
				)}
				{!isLoggedIn && (
					<>
						<Hidden smDown>
							<Button
								className={classes.authLink}
								onClick={() => {
									UserManager.openLoginModal();
								}}
							>
								Sign in
							</Button>
							<Button
								className={`${classes.authLink} ${classes.authAccent}`}
								onClick={() => {
									UserManager.openRegisterModal();
								}}
							>
								Register
							</Button>
						</Hidden>
						<Hidden mdUp>
							<Button
								className={classes.authLink}
								onClick={() => {
									UserManager.openLoginModal();
								}}
							>
								Sign in
							</Button>
						</Hidden>
					</>
				)}
			</div>
		);
	};

	return (
		<AppBar position="static" className={classes.navbar}>
			<Toolbar variant="dense" className={classes.toolbar}>
				{tab === "pickems" && (
					<div className={classes.burgerWrap}>
						<IconButton
							aria-label="open drawer"
							onClick={handleDrawerToggle}
							edge="start"
						>
							<MenuIcon className={classes.userIcon} />
						</IconButton>
					</div>
				)}
				<PickstopLogo className={classes.logo} onClick={() => changeUrl("/")} />
				<span className={classes.brandDividerLogo} aria-hidden="true" />
				{props.games && (
					<div className={classes.gameMenuArea}>
						<Button
							classes={gameMenuClasses}
							aria-controls="simple-menu"
							aria-haspopup="true"
							onClick={handleMainMenuClick}
							endIcon={<ExpandMore />}
						>
							<span className={classes.gameLabel}>Game</span>
							<span className={classes.gameName}>{selectedGame?.name}</span>
						</Button>
						<Menu
							id="game-menu"
							classes={{ paper: classes.menu }}
							anchorEl={mainAnchorEl}
							anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
							transformOrigin={{ vertical: "top", horizontal: "left" }}
							getContentAnchorEl={null}
							open={Boolean(mainAnchorEl)}
							onClose={handleMainMenuClose}
						>
							{props.games?.map((game, i) => {
								const isCurrent = game.id === gameId;
								return (
									<MenuItem
										key={i}
										className={isCurrent ? classes.gameMenuItemActive : ""}
										onClick={() => handleSetGame(game.id)}
									>
										{game.name}
									</MenuItem>
								);
							})}
						</Menu>
						<span className={classes.brandDivider} aria-hidden="true" />
					</div>
				)}

				{<TopIconMenu hasSurvey={!!props.currentSurvey} />}

				{renderAuthMenuItems()}
				{renderCompactMenu()}
			</Toolbar>
		</AppBar>
	);
}

const NavMenu = withRouter((props) => connect(<NavMenuC />, propKeys, props));

export default NavMenu;
